import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {DecimalPipe} from "@angular/common";
import * as Sentry from "@sentry/angular";
import {Subscription} from "rxjs";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {ModeratRequestService} from "../services/request.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-sanierung-economic',
  templateUrl: './sanierung-economic.component.html',
  providers: [DecimalPipe]
})
export class SanierungEconomicComponent implements OnInit, OnDestroy {

  /**
   * the configuration of the costs we want to display
   */
  @Input() costs: any;

  /**
   * eventmemitter that is fired every time the costs changes, so we can update the component.
   */
  @Input() costChanges: EventEmitter<any>;

  /**
   * remember the subscriptions so we can unsubscribe after leaving the component.
   */
  subscriptions: Subscription[] = [];

  /**
   * factor for the bar-scaling
   */
  barFactor: number = 1;

  /**
   * eome toggles for help texts
   */
  toggles: {[key: string]: boolean} = {help1: false, help2: false};

  /**
   * holds the current users anfrage
   */
  anfrage: ModeratAnfrage;

  /**
   * Sum of the monthly equity credit
   */
  equityCredit: number = 0;

  /**
   *
   * @param decimapPipe
   * @param requestService
   * @param translateService
   */
  constructor(private decimapPipe: DecimalPipe, protected requestService: ModeratRequestService, protected translateService: TranslateService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.anfrage = this.requestService.getAnfrage();

    this.subscriptions.push(
      this.costChanges.subscribe(costs => {
        // recalculate the bar heights
        this.costs = costs;
        this.barFactor = 0.5;
        if(costs.overall.repair + costs.overall.modernization > 0) {
          this.barFactor = costs.overall.modernization / (costs.overall.repair + costs.overall.modernization);
        }

        // recalculate equity credit
        this.calculateCreditValue();
      })
    );
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * formats an amount with sign and unit
   */
  formatAmount(amount: number): string {
    let format = amount > 0? '+' : '';
    if(isNaN(amount)) {
      Sentry.captureMessage('formatAmount(): value ist Nan ' + amount);
      format += amount;
    }
    else {
      try {
        if(typeof amount !== "number") {
          amount = parseFloat(amount);
        }
        format += this.decimapPipe.transform(amount, '1.0-0');
      }
      catch (e) {
        Sentry.captureException(e)
        Sentry.captureMessage('formatAmount(): Could not format value ' + amount + ". Type: " + typeof amount + ". Browserlang: " + this.translateService.getBrowserLang());
        format += amount;
      }
    }
    return format + ' €';
  }

  /**
   * (re)calculate the credit value for the result table
   */
  calculateCreditValue(): void {
    if(!this.costs || !this.costs.monthly_balance) {
      // stop here, no costs set
      return;
    }

    const creditSum = this.costs.overall.sum - this.costs.funding_grants.sum - this.anfrage.eigenkapital - this.costs.promotional_loan.sum;
    if(this.costs?.creadit_factor && creditSum > 0) {
      this.equityCredit = creditSum * this.costs.creadit_factor / 1000 / 12;
    }
    else {
      this.equityCredit = 0;
    }

    // recalculate the sum, do this with timeout to avoid angular errors
    setTimeout(() => {
      if(this.costs?.monthly_balance) {
        this.costs.monthly_balance.sum = ((this.costs.monthly_balance.credit + this.equityCredit) * -1) + this.costs.monthly_balance.saving;
      }
    }, 0);
  }

}
